export default {
  SET_LICENSE_DEFINITION(state, payload) {
    state.license_definition = payload;
  },

  SET_HAVING_LICENSE(state, payload) {
    state.having_license = payload;
  },

  ADD_HAVING_LICENSE(state, payload) {
    state.having_license.push(payload);
  },

  UPDATE_HAVING_LICENSE(state, payload) {
    const index = state.having_license.findIndex(
      item => item.id === payload.id
    );
    if (index !== -1) {
      state.having_license.splice(index, 1, payload);
    }
  },

  DELETE_HAVING_LICENSE(state, payload) {
    const index = state.having_license.findIndex(
      item => item.id === payload.id
    );
    if (index !== -1) {
      state.having_license.splice(index, 1);
    }
  },

  RESET_STATE(state) {
    state.license_definition = [];
    state.having_license = [];
  },
};

